/**
=========================================================
* Soft UI Dashboard React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
/* eslint-disable */
import { useState, useEffect, useContext } from "react";

// react-router components
import { useLocation, Link, useNavigate } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @material-ui core components
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiAvatar from "components/SuiAvatar";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
// Soft UI Dashboard React examples
import NotificationItem from "examples/Items/NotificationItem";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import boxShadows from "assets/theme/base/boxShadows";
import NotificationDrawer from "./../../../layouts/notification/NotificationDrawer";
// Custom styles for DashboardNavbar
import {
  navbarRow,
  navbarIconButton,
  navbarMobileMenu,
  greetings,
} from "examples/Navbars/DashboardNavbarCustom/styles";

// Soft UI Dashboard React context
import { useSoftUIController } from "context";
import { setTransparentNavbar, setMiniSidenav } from "context/theme/action";
import SampleLogo from "assets/images/logos/LogoZumi.png";
// Images
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Badge,
  Popover,
  Link as MuiLink,
} from "@mui/material";
import routes from "routes";
import { clearLocalStorage, getLocalUserInfo } from "utils/storage";
import { clearAccount } from "context/account/action";
import SupportIcon from "assets/images/support-icon.svg";
import { checkUrlImage, isBase64 } from "utils/utils";
import { setAlertMessage, setIsStickyBtn } from "context/common/action";
import imgVector from "assets/images/icons/Vector_new.svg";
import ChangePassDialog from "./component/ChangePassDialog";
import avaImg from "assets/images/default-avt.jpg";
import UserService from "service/UserSerivce";
import MoveToInboxIcon from "@mui/icons-material/MoveToInbox";
import GroupIcon from "@mui/icons-material/Group";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import RoomPreferencesIcon from "@mui/icons-material/RoomPreferences";
import ArticleIcon from "@mui/icons-material/Article";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import HomeIcon from "@mui/icons-material/Home";
import SettingsIcon from "@mui/icons-material/Settings";
import ListAltIcon from "@mui/icons-material/ListAlt";
import DescriptionIcon from "@mui/icons-material/Description";
import TaskIcon from "@mui/icons-material/Task";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import DynamicFormIcon from "@mui/icons-material/DynamicForm";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import { getMenus } from "api/DashboardAPI";
import { getNotifications, countNotifications } from "api/NotifyAPI";
import { getImageUrl } from "api/ImageViewer";
import { getWebsite } from "api/configWebsiteAPI";
import { useColorTheme } from "../../../context/ColorThemeContext";

const { xxl } = boxShadows;

function utf8Decode(utftext) {
  let string = "";
  let i = 0;
  let c = 0;
  let c2 = 0;
  let c3 = 0;

  while (i < utftext.length) {
    c = utftext.charCodeAt(i);
    if (c < 128) {
      string += String.fromCharCode(c);
      i += 1;
    } else if (c > 191 && c < 224) {
      c2 = utftext.charCodeAt(i + 1);
      // eslint-disable-next-line no-bitwise
      string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
      i += 2;
    } else {
      c2 = utftext.charCodeAt(i + 1);
      c3 = utftext.charCodeAt(i + 2);
      // eslint-disable-next-line no-bitwise
      string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
      i += 3;
    }
  }
  return string;
}

function DashboardNavbarCustom({ absolute, light, isMini, page, childPage, backButton, header }) {
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem("user"));
  const [headerData, setHeaderData] = useState({
    email: "",
    phone: "",
    logo: "",
    preview: "",
  });
  function resolvePreviewSrc(logo) {
    if (!logo) return "";
    if (typeof logo === "string") {
      return logo.startsWith("data:image") ? logo : getImageUrl(logo);
    }
    if (logo instanceof File) {
      return URL.createObjectURL(logo);
    }
    return "";
  }
  useEffect(() => {
    if (header) {
      setHeaderData({
        email: header?.email || "",
        phone: header?.phone || "",
        preview: resolvePreviewSrc(header?.logo),
        logo: header?.logo || "",
      });
    }
  }, [header]);
  async function fetchConfig() {
    const data = await getWebsite();
    if (data) {
      try {
        const parsedHeader = JSON.parse(data.header);
        setHeaderData({
          email: parsedHeader?.email || "",
          phone: parsedHeader?.phone || "",
          preview: resolvePreviewSrc(parsedHeader?.logo),
          logo: parsedHeader?.logo || "",
        });
      } catch (err) {
        console.error("Lỗi parse JSON:", err);
      }
    }
  }
  useEffect(() => {
    fetchConfig();
  }, []);
  const imgLogo = userData?.imgLogo || ""; // fallback nếu không có
  const isSignIn = true;
  const [navbarType, setNavbarType] = useState();
  const [avatar, setAvatar] = useState(null);
  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav, transparentNavbar, fixedNavbar } = controller.theme;
  const { isStickyBtn } = controller.common;
  const [openMenu, setOpenMenu] = useState(false);
  const [openUserOptions, setOpenUserOptions] = useState(false);
  const [openChangePassword, setOpenChangePassword] = useState(false);
  const route = useLocation().pathname.split("/").slice(1);
  // const { roleName, fullName } = JSON.parse(localStorage.getItem("user"));
  const title = [];
  const path = [];
  //thong bao
  const [openNotificationDrawer, setOpenNotificationDrawer] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [countNotify, setCountNotify] = useState([]);
  const loadNotifications = () => {
    getNotifications()
      .then((result) => {
        console.log(result.lstNotify);
        setNotifications(result.lstNotify);
      })
      .catch((error) => console.error("Error fetching users", error));
  };
  const iconMap = {
    HOME_PAGE: <HomeIcon fontSize="large" htmlColor="#FFFFFF" />,
    SYSTEM_ADMINISTRATION: <SettingsIcon fontSize="large" htmlColor="#FFFFFF" />,
    DOCUMENT_OUT: (
      <MoveToInboxIcon fontSize="large" htmlColor="#FFFFFF" sx={{ transform: "rotate(180deg)" }} />
    ),
    PROJECT_MANAGEMENT: <MenuBookIcon fontSize="large" htmlColor="#FFFFFF" />,
    USER_MANAGEMENT: <GroupIcon fontSize="large" htmlColor="#FFFFFF" />,
    LOG_MANAGEMENT: <FormatListBulletedIcon fontSize="large" htmlColor="#FFFFFF" />,
    ROLE_MANAGEMENT: <AdminPanelSettingsIcon fontSize="large" htmlColor="#FFFFFF" />,
    DEPARTMENT_MANAGEMENT: <HomeWorkIcon fontSize="large" htmlColor="#FFFFFF" />,
    ADMINISTRATIVE_AREA: <RoomPreferencesIcon fontSize="large" htmlColor="#FFFFFF" />,
    TYPE_OF_DISPATCH: <DescriptionIcon fontSize="large" htmlColor="#FFFFFF" />,
    CATEGORY_MANAGEMENT: <ListAltIcon fontSize="large" htmlColor="#FFFFFF" />,
    WORK_MANAGEMENT: <TaskIcon fontSize="large" htmlColor="#FFFFFF" />,
    PROCESS_MANAGEMENT: <DynamicFormIcon fontSize="large" htmlColor="#FFFFFF" />,
    PROCESS_TYPE_MANAGEMENT: <DynamicFormIcon fontSize="large" htmlColor="#FFFFFF" />,
    EFORM_MANAGEMENT: <ArticleIcon fontSize="large" htmlColor="#FFFFFF" />,
    PARTNER_MANAGEMENT: <PeopleAltIcon fontSize="large" htmlColor="#FFFFFF" />,
    GOVERNMENT_CIRCULAR: <AssuredWorkloadIcon fontSize="large" htmlColor="#FFFFFF" />,
    REPORT_HASHTAG: <AccountTreeIcon fontSize="large" htmlColor="#FFFFFF" />,
  };
  //end thong bao
  //start menu
  const [anchorElPopover, setAnchorElPopover] = useState(null);
  const handleAvatarClick = (event) => {
    setAnchorElPopover(event.currentTarget);
  };
  const token = localStorage.getItem("token");
  const [menuItems, setMenuItems] = useState([]);
  const openPopover = Boolean(anchorElPopover);
  const currentRouteMode = route[0];
  const colors = useColorTheme();
  const loadCountNotify = () => {
    countNotifications()
      .then((result) => {
        console.log(result.countNotify);
        setCountNotify(result.countNotify);
      })
      .catch((error) => console.error("Error fetching users", error));
  };

  // useEffect(() => {
  //   const token = localStorage.getItem("token");
  //   if (!token) {
  //     navigate("/");
  //   } else {
  //     getMenus()
  //       .then((result) => {
  //         const menusWithIcons = result.menus.map((item) => ({
  //           ...item,
  //           icon: iconMap[item.permissionCode] || (
  //             <HelpOutlineIcon fontSize="large" htmlColor="#FFFFFF" />
  //           ),
  //         }));
  //         setMenuItems(menusWithIcons);
  //       })
  //       .catch((error) => console.error("Error fetching users", error));
  //   }
  //   loadCountNotify();
  // }, []);

  const onRefreshDataChange = () => {
    loadNotifications();
    loadCountNotify();
  };
  //end menu
  if (route[0] === "operator" || route[0] === "client") route.shift();
  for (let i = 0; i < route.length; i++) {
    let hasKey = false;
    let isCollapse = false;
    routes.forEach((item) => {
      if (route[i] === item.key) {
        if (item.type === "single" && currentRouteMode === item.route.split("/").slice(1)[0]) {
          title.push(item.title);
          path.push(item.route);
          hasKey = true;
          isCollapse = true;
        } else if (item.type === "title") {
          item?.collapse.map((miniItem) => {
            if (
              miniItem.key === route[i + 1] &&
              currentRouteMode === miniItem.route.split("/").slice(1)[0]
            ) {
              title.push(miniItem.name);
              path.push(miniItem.route);
              hasKey = true;
              isCollapse = true;
              i++;
            }
            return title;
          });
        } else if (currentRouteMode === item.route.split("/").slice(1)[0]) {
          if (item.name) {
            title.push(item.name);
            path.push(item.route);
            hasKey = true;
            isCollapse = true;
          }
        }
      }
    });

    if ((!hasKey || !isCollapse) && path.length > 0) {
      title.push(utf8Decode(unescape(route[i])));
      path.push(path[path.length - 1]?.concat(`/${route[i]}`));
    }
  }
  const handleClosePopover = () => {
    setAnchorElPopover(null);
  };
  useEffect(() => {
    // Setting the navbar type
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }

    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      setIsStickyBtn(dispatch, window.scrollY > 64);
    }

    /** 
     The event listener that's calling the handleTransparentNavbar function when 
     scrolling the window.
    */
    window.addEventListener("scroll", handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);
  const handleCloseMenu = () => setOpenMenu(false);
  const handleOpenUserOptions = (event) => setOpenUserOptions(event.currentTarget);
  const handleCloseUserOptions = () => setOpenUserOptions(false);

  const handleUserChangePassword = () => (
    <ChangePassDialog
      open={openChangePassword}
      setOpen={setOpenChangePassword}
      // onClick={() => setOpenChangePassword(false)}
      label={["Mật khẩu hiện tại", "Mật khẩu mới", "Nhập lại mật khẩu mới"]}
    />
  );

  const renderUserOptions = () => (
    <Menu
      anchorEl={openUserOptions}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openUserOptions)}
      onClose={handleCloseUserOptions}
      sx={{ mt: 2 }}
    >
      <NotificationItem
        image={
          <Icon fontSize="small" sx={{ color: ({ palette: { white } }) => white.main }}>
            personal_outline
          </Icon>
        }
        title={["", "Xem thông tin tài khoản"]}
        onClick={() => {
          navigate("/user-detail");
        }}
        color="black"
      />
      <NotificationItem
        image={
          <Icon fontSize="small" sx={{ color: ({ palette: { white } }) => white.main }}>
            password
          </Icon>
        }
        title={["", "Đổi mật khẩu"]}
        onClick={() => {
          setOpenChangePassword(true);
        }}
        color="black"
      />
      {/* <NotificationItem
        image={
          <Icon fontSize="small" sx={{ color: ({ palette: { white } }) => white.main }}>
            download
          </Icon>
        }
        title={["", "Tải file hướng dẫn"]}
        onClick={() => {
          const link = document.createElement("a");
          link.href = `${process.env.PUBLIC_URL}/sample-import/Tai_lieu_huong_dan_su_dung_SSO_v1.0.pdf`;
          link.download = "Tai_lieu_huong_dan_su_dung_SSO_v1.0.pdf";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }}
        color="black"
      /> */}
      <NotificationItem
        image={
          <Icon fontSize="small" sx={{ color: ({ palette: { white } }) => white.main }}>
            logout
          </Icon>
        }
        title={["", "Đăng xuất"]}
        onClick={() => {
          clearLocalStorage();
          clearAccount(dispatch);
          navigate("/", { replace: true });
        }}
        color="black"
      />
    </Menu>
  );

  const [nameAccount, setNameAccount] = useState("");
  return (
    <>
      <AppBar
        position={absolute ? "absolute" : navbarType}
        color="inherit"
        sx={{
          background: "#EFF0F2",
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.03)",
          marginBottom: "10px",
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#ffffff",
            px: 2,
          }}
        >
          <Box sx={{ flex: 1, display: { xs: "none", md: "block" } }} />

          {/* Giữa: Logo + Info trái/phải logo */}
          <Box
            sx={{
              flex: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
            }}
          >
            {/* BÊN TRÁI LOGO: Email + Phone */}
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                alignItems: { xs: "flex-start", md: "center" },
                gap: 1,
                position: { xs: "static", md: "absolute" },
                right: { md: "100%" },
                marginRight: { md: 2 },
                whiteSpace: "nowrap",
              }}
            >
              {/* Email */}
              <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                <EmailIcon sx={{ fontSize: { xs: 12, sm: 14, md: 16 }, color: "#333" }} />
                <Typography
                  component="a"
                  href="mailto:Kinhdoanh@zumi.com.vn"
                  sx={{
                    fontSize: { xs: 12, sm: 14, md: 16 },
                    fontWeight: 700,
                    color: "#333",
                    textDecoration: "none",
                    transition: "filter 0.3s ease, transform 0.3s ease",
                    "&:hover, &:focus": {
                      // filter: "brightness(1.2)",
                      transform: "scale(1.03)",
                      textDecoration: "none",
                    },
                  }}
                >
                  {headerData.email}
                </Typography>
              </Box>

              {/* Phone */}
              <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                <PhoneIcon sx={{ fontSize: { xs: 12, sm: 14, md: 16 }, color: "#333" }} />
                <Typography
                  component="a"
                  href={`tel:${headerData.phone}`}
                  sx={{
                    fontSize: { xs: 12, sm: 14, md: 16 },
                    fontWeight: 700,
                    color: "#333",
                    textDecoration: "none",
                    transition: "filter 0.3s ease, transform 0.3s ease",
                    "&:hover, &:focus": {
                      // filter: "brightness(1.2)",
                      transform: "scale(1.03)",
                      textDecoration: "none",
                    },
                  }}
                >
                  {headerData.phone}
                </Typography>
              </Box>
            </Box>

            {/* LOGO CHÍNH GIỮA */}
            <Box
              onClick={() => {
                window.location.href = "https://zumi.com.vn";
              }}
              sx={{
                pl: 1,
                display: "inline-block",
                cursor: "pointer",
                transition: "filter 0.3s ease, transform 0.3s ease",
                "&:hover, &:focus": {
                  filter: "brightness(1.2)",
                  transform: "scale(1.03)",
                },
              }}
            >
              <Box
                component="img"
                src={headerData.preview}
                alt="Logo"
                sx={{
                  height: { xs: 30, sm: 40, md: 60 },
                  alignSelf: "center",
                  my: { xs: 1, md: 1 },
                }}
              />
            </Box>

            {/* BÊN PHẢI LOGO: Đăng nhập */}
            <Box
              sx={{
                position: "absolute",
                left: "100%",
                ml: 2,
                display: "flex",
                flexDirection: "row", // ❗ Không cho xuống dòng
                alignItems: "center",
                gap: 0.5,
                whiteSpace: "nowrap",
                fontSize: { xs: "10px", sm: "12px", md: "16px" },
              }}
            >
              <AccountCircleIcon sx={{ fontSize: { xs: 14, sm: 18 }, color: "#0094FF" }} />
              {userData?.userId ? (
                <Typography
                  variant="caption"
                  sx={{
                    fontSize: { xs: "10px", sm: "12px", md: "16px" },
                    fontWeight: "bold",
                    color: "#0094FF",
                    cursor: "pointer",
                  }}
                  onClick={() => navigate("/profile")}
                >
                  {userData?.fullName}
                </Typography>
              ) : (
                <>
                  <Typography
                    variant="caption"
                    sx={{
                      fontSize: { xs: "10px", sm: "12px", md: "16px" },
                      fontWeight: "bold",
                      color: "#0094FF",
                      cursor: "pointer",
                    }}
                    onClick={() => navigate("/authentication/sign-in")}
                  >
                    Đăng nhập
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      fontSize: { xs: "10px", sm: "12px", md: "16px" },
                      fontWeight: "bold",
                      color: "#0094FF",
                    }}
                  >
                    /
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      fontSize: { xs: "10px", sm: "12px", md: "16px" },
                      fontWeight: "bold",
                      color: "#0094FF",
                      cursor: "pointer",
                    }}
                    onClick={() => navigate("/authentication/sign-up")}
                  >
                    Đăng ký
                  </Typography>
                </>
              )}
            </Box>
          </Box>

          {/* Phải: trống để giữ logo luôn ở center */}
          <Box sx={{ flex: 1 }} />
        </Toolbar>
      </AppBar>
      <NotificationDrawer
        openNotificationDrawer={openNotificationDrawer}
        setOpenNotificationDrawer={setOpenNotificationDrawer}
        notifications={notifications}
        iconMap={iconMap}
        onRefreshDataChange={onRefreshDataChange}
      />
      {/* Popover menu for avatar click */}
      <Popover
        open={openPopover}
        anchorEl={anchorElPopover}
        onClose={handleClosePopover}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            mt: 1,
            p: 2,
            backgroundColor: colors.popupBackground || "#3C7363",
            color: "white",
            borderRadius: 3,
            width: 380, // Tăng chiều rộng của popup
            minHeight: "fit-content", // mặc định
            overflow: "hidden", // Cho phép cuộn nếu nội dung quá dài
          },
        }}
      >
        <Box sx={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 3 }}>
          {menuItems.map(({ title, icon, link }, index) => (
            <Box
              key={index}
              sx={{
                textAlign: "center",
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "8px",
                transition: "background-color 0.3s, transform 0.3s",
                "&:hover": {
                  backgroundColor: "rgba(255,255,255,0.1)",
                  transform: "scale(1.05)",
                },
              }}
              onClick={() => {
                handleClosePopover();
                navigate(link);
                window.location.reload();
              }}
            >
              {icon}
              <Typography
                variant="caption"
                sx={{
                  textAlign: "center",
                  color: "#fff",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  letterSpacing: 1,
                  mt: 0.5,
                }}
              >
                {title}
              </Typography>
            </Box>
          ))}
        </Box>
      </Popover>
    </>
  );
}

// Setting default values for the props of DashboardNavbar
DashboardNavbarCustom.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
  page: "",
  childPage: [],
  backButton: () => {},
};

// Typechecking props for the DashboardNavbar
DashboardNavbarCustom.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
  page: PropTypes.string,
  childPage: PropTypes.array,
  backButton: PropTypes.func,
  header: PropTypes.shape({
    email: PropTypes.string,
    phone: PropTypes.string,
    logo: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object, // nếu có thể là File
    ]),
  }).isRequired,
};

export default DashboardNavbarCustom;
